import { cn } from "@/lib/cn";

export type AvatarRole = "default" | "founder" | "writer" | "producer" | "ai";

const ROLE_CLASS: Record<AvatarRole, string> = {
  default: "",
  founder: "avatar-founder",
  writer: "avatar-writer",
  producer: "avatar-producer",
  ai: "avatar-ai",
};

export interface AvatarProps {
  role?: AvatarRole;
  title?: string;
  className?: string;
  children: React.ReactNode;
}

/** 原型基元：`.avatar`（+ `avatar-founder/writer/producer/ai`）。 */
export function Avatar({ role = "default", title, className, children }: AvatarProps) {
  return (
    <span className={cn("avatar", ROLE_CLASS[role], className)} title={title}>
      {children}
    </span>
  );
}
